import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArchiveIcon from "@mui/icons-material/Archive";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TableChartIcon from "@mui/icons-material/TableChart";
import ArticleIcon from "@mui/icons-material/Article";
import ImageIcon from "@mui/icons-material/Image";

export const formatFileSize = (size) => {
  if (size < 1024) return `${size} B`;
  if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
  return `${(size / 1048576).toFixed(2)} MB`;
};

export const getStatusColor = (status) => {
  const lowerStatus = status?.toLowerCase();
  switch (lowerStatus) {
    case "onaylandı":
    case "aktif":
    case "kullanımda":
      return "success";
    case "onay bekliyor":
      return "warning";
    case "reddedildi":
    case "pasif":
      return "error";
    case "boşta":
      return "default";
    default:
      return "default";
  }
};

/** Lisans durumu: Etkin ve BitisTarih'e göre tek kaynak. Pasif = Etkin false veya bitiş geçmiş. */
export const isLisansAktif = (lisans) => {
  if (!lisans) return false;
  if (lisans.Etkin === false || lisans.Etkin === 0) return false;
  if (lisans.BitisTarih) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bitis = new Date(lisans.BitisTarih);
    bitis.setHours(0, 0, 0, 0);
    if (bitis < today) return false;
  }
  return true;
};

/** Lisans için gösterim metni: "Aktif" | "Pasif" */
export const getLisansDurumLabel = (lisans) => (isLisansAktif(lisans) ? "Aktif" : "Pasif");

export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("tr-TR");
};

export const getFileIcon = (type = "") => {
  if (type.includes("pdf")) return <PictureAsPdfIcon color="error" />;
  if (type.includes("zip")) return <ArchiveIcon color="primary" />;
  if (type.includes("xlsx") || type.includes("spreadsheet"))
    return <TableChartIcon color="success" />; // Excel
  if (type.includes("xml")) return <DescriptionIcon color="info" />;
  if (type.includes("docs")) return <ArticleIcon color="info" />; // Word
  if (type.includes("png") || type.includes("jpg") || type.includes("jpeg"))
    return <ImageIcon color="warning" />; // Resim
  return <InsertDriveFileIcon color="disabled" />;
};
